import NotificationDispatcher from "../core/notification-dispatcher/NotificationDispatcher";

const copyTextToClipboard = (notificationDispatcher: NotificationDispatcher): CopyTextToClipboard => text => {
    navigator.clipboard.writeText(text);
    notificationDispatcher.dispatchSuccess('Skopiowano do schowka');
}
export default copyTextToClipboard;

export type CopyTextToClipboard = (text: string) => void;